/**
 *
 * Asynchronously loads the component for MessagePage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const MessagePage = lazyLoad(
  () => import('./index'),
  module => module.MessagePage,
);
